import { Button } from "@shared/ui";

import { ReportingArea } from "../../lib/reports";
import { useReport } from "./ReportProvider";

type ReportLinkProps = {
  area: ReportingArea;
  step: string;
};

const ReportLink = ({ area, step }: ReportLinkProps) => {
  const reporting = useReport();

  return (
    <Button
      variant="text"
      type="button"
      onClick={() => reporting?.open(area, step)}
    >
      Report a problem
    </Button>
  );
};

export default ReportLink;
